import { render, staticRenderFns } from "./SendOrder.vue?vue&type=template&id=4f49a96e&scoped=true"
import script from "./SendOrder.vue?vue&type=script&lang=js"
export * from "./SendOrder.vue?vue&type=script&lang=js"
import style0 from "./SendOrder.vue?vue&type=style&index=0&id=4f49a96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f49a96e",
  null
  
)

export default component.exports